var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._v(" Hello Carbon! Well, not quite yet. This is the starting point for the Carbon tutorial. ")])}
var staticRenderFns = []

export { render, staticRenderFns }